module.exports = __webpack_public_path__ + "img/login-ciudadelamexico.b76cadaf.svg";